import {  httpOptionsDefault } from '../../_shared/constants';
import { Injectable } from '@angular/core';
import { MayHaveId } from './db-list-base';
import { HttpHeaders,HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { MongoBody } from '../database-cast/mongo/http-mongo';
import { WebApiService } from '../WebApiService';



// @Injectable()
// export class DbTable<T extends MayHaveId>
// {


//     protected _controllerName: string;

//     constructor(public _http: HttpClient, public controllerName: string) {
//         this._controllerName = controllerName;
//     }

//     public getList(startPos: number, length: number, searchText: string): Promise<T[]> {

//         console.log("Aquiiiiiii");

//        console.log(this._webApi.GetApiAddress() + `/${this._controllerName}/search/${startPos}/${length}/${searchText}`);
       
//         searchText += "";
//         return this._http.get(this._webApi.GetApiAddress() + `/${this._controllerName}/search/${startPos}/${length}/${searchText}`)
//         .pipe(
//             map((result: any) => {
//                 let list: T[] = result;
             
//                 return list;

//             })
//         ).toPromise();
//     }

//     public getCount(searchText: string): Promise<number> {

//         searchText += "";
//         return this._http.get(this._webApi.GetApiAddress() + `/${this._controllerName}/count/${searchText}`)
//         .pipe(
//             map((result: any) => {
//                 let list: number = result;
//                 console.log(list);
//                 return list;

//             })).toPromise();
//     }

//     public getItem(id: number|string) {
//         return this._http.get(this._webApi.GetApiAddress() + `/${this._controllerName}/` + `${id}`)
//         .pipe(
//             map((result: any) => {
//                 //   console.log(result);
//                 return result;
//             })).toPromise();
//     }


//     put(data: T): Promise<T> {

      
        

//         let body = JSON.stringify(data);
//         //  let headerOptions =new Headers();
//         if (data.id > 0) { 
            
//             console.log("Atualizando ");
//             console.log(data);

//             const httpHeaders = new HttpHeaders();
//             httpHeaders.set('Content-Type', 'application/json');
//           return  this._http.post(this._webApi.GetApiAddress() + `/${this._controllerName}/${data.id}`, body,  httpOptionsDefault)

         
//            .pipe(
//             map((result: any) => {
              
//                 return result;

//             })).toPromise();
    

//         }
//         else {

//             console.log("Adicionando");
//             console.log(data);

//             const httpHeaders = new HttpHeaders();
//             httpHeaders.set('Content-Type', 'application/json');

//             console.log("Registro:");
//             console.log(data);
//             return this._http.post(this._webApi.GetApiAddress() + `/${this._controllerName}`, body,  httpOptionsDefault)
//             .pipe(map((result: T)=>result))
//                 .toPromise();
          
//         }

//     }
// }



export class DbTable<T extends MayHaveId>
{


    protected _controllerName: string;

    constructor(public _http: HttpClient,public _webApi:WebApiService, public controllerName: string) {
        this._controllerName = controllerName;
    }

    public getList(startPos: number, length: number, searchText: string): Promise<T[]> {

     
        searchText += "";
        return this._http.get(this._webApi.GetApiAddress() + `/${this._controllerName}/search/${startPos}/${length}/${searchText}`)
            .pipe(
                map((result: T[]) => {
                    // let list: T[] = result.json();
                    // console.log(list);
                    return result;

                })).toPromise();
    }

    public getCount(searchText: string): Promise<number> {

        searchText += "";
        return this._http.get(this._webApi.GetApiAddress() + `/${this._controllerName}/count/${searchText}`)
            .pipe(
                map((result: any) => {
                    let list: number = result;
                    console.log(list);
                    return list;

                })).toPromise();
    }

    public getItem(id: string|number) {

    

        return this._http.get(this._webApi.GetApiAddress() + `/${this._controllerName}/` + `${id}`)
            .pipe(
                map((result: any) => {
                    //   console.log(result);
                    return result;
                })

            ).toPromise();
    }


    remove(id: string|number): Promise<T> {

 

        return this._http.delete(this._webApi.GetApiAddress() + `/${this._controllerName}/${id}`,  httpOptionsDefault)
        .pipe(
            map((result:T)=>
            {
              
               return  result;
            })
        )
        .toPromise();

    }

    put(data: T, keyField: string): Promise<T> {

    
        let body = JSON.stringify(data);

        let id = null;

        if (keyField != null && keyField != "") {
            id = data[keyField];
        }
        else {
            id = data.id;
        }
        //  let headerOptions =new Headers();
        if (id != null && id != "") {

     
            return this._http.put(this._webApi.GetApiAddress() + `/${this._controllerName}/${id}`, body, httpOptionsDefault)
                .toPromise().then(x => {
                    let result: T;
                    result = Object.assign(result, x);
                    return result;
                });
       

        }
        else {



         return this._http.post(this._webApi.GetApiAddress() + `/${this._controllerName}/add`,  body, httpOptionsDefault)

            .pipe(
                map(result => {

           
                    return result;
                }

                ),
                catchError(error=>
                    {
                       
                      return   error;
                    })
        )
                .toPromise().then((result:T )=> {

             
                    return result;
                    // LottolocaDebugger.log(500,"Retorno");
                    // LottolocaDebugger.log(500,x);
                    // let result: T;
                    // result = Object.assign(result, x);
                    // return result;
                });
        
        }

    }

 
}